<script setup>
defineProps({
  className: {
    type: String,
    default: undefined,
  },
});

const route = useRoute();
const localeRoute = useLocaleRoute();
const searchStore = useSearchStore();

// breakpoint
const breakpoint = useCustomBreakpoints();
const breakpointDownSm = breakpoint.smaller('sm');

// Scroll handling
let lastScrollY = 0;
const isScrollingDown = ref(false);

const isFormVisible = ref(true);
const isHeadingVisible = ref(true);

let formScrollValue = 608;
let headingScrollValue = 136;

let hideHeaderScrollValue =
  route.name === localeRoute('index').name ? 405 : 100;

onMounted(() => {
  lastScrollY = window.scrollY;
  formScrollValue = toResizedPx(formScrollValue);
  headingScrollValue = toResizedPx(headingScrollValue);
  hideHeaderScrollValue = toResizedPx(hideHeaderScrollValue);

  handleScroll();
});
useEventListener('scroll', handleScroll);

function handleScroll() {
  const currentScrollY = window.scrollY;

  isScrollingDown.value =
    currentScrollY > lastScrollY &&
    !breakpointDownSm.value &&
    hideHeaderScrollValue < currentScrollY;

  lastScrollY = currentScrollY;

  isFormVisible.value = currentScrollY <= formScrollValue;
  isHeadingVisible.value = currentScrollY <= headingScrollValue;
}

function scrollToTop() {
  window.scrollTo({
    top: 0,
    behavior: 'smooth',
  });
}
</script>

<template>
  <div class="layouts-seo" :class="className">
    <LayoutHeader
      class="layouts-seo__header"
      :class="{ 'layouts-seo__header--scrolled': isScrollingDown }"
      :is-form-visible="isFormVisible"
      :is-heading-visible="isHeadingVisible"
    />

    <BlocksPageHeading
      class="layouts-seo__heading"
      :class="{
        'layouts-seo__heading--vertical-paddings': !!route.meta.titleKey,
      }"
      :title-key="route.meta.titleKey"
      :text-key="route.meta.textKey"
    />

    <LayoutFormSearch
      class="layouts-seo__form"
      :class="{ 'layouts-seo__form--scrolled': isScrollingDown }"
    />

    <Transition name="slide-top">
      <BlocksFormHeader
        v-show="
          searchStore.filters?.departureStation &&
          searchStore.filters?.arrivalStation
        "
        class="layouts-seo__form-header hidden-desktop"
        @click="scrollToTop"
      />
    </Transition>

    <slot class-name="layouts-seo__view" />

    <div class="layouts-seo__footer-wrapper">
      <LazyLayoutFooter class="layouts-seo__footer" />
    </div>
  </div>
</template>
